var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThinnectWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 422 82",
    enableBackground: "new 0 0 422 82",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "current",
    stroke: "current",
    points: "11.4,23.4 27.4,23.4 27.4,66.5 36,66.5 36,23.4 52.1,23.4 52.1,15.7 11.4,15.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "current",
    stroke: "current",
    points: "104.9,37.7 78,37.7 78,15.7 69.4,15.7 69.4,66.5 78,66.5 78,45.4 104.9,45.4 104.9,66.5 113.4,66.5 113.4,15.7 104.9,15.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.6,
    y: 15.7,
    fill: "current",
    stroke: "current",
    width: 8.6,
    height: 50.8
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "current",
    stroke: "current",
    points: "270.4,44.8 295.3,44.8 295.3,37.1 270.4,37.1 270.4,23.4 298.2,23.4 298.2,15.7 261.9,15.7 261.9,66.5 299,66.5 299,58.8 270.4,58.8  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    d: "M338.8,58.8c-10.1,0-18.1-7.9-18.1-17.9c0-10,8-17.9,18.1-17.9c5.2,0,10.5,2.5,14.2,6.5l5-6.2 c-4.9-4.9-12.1-7.8-19.3-7.8c-15,0-26.7,11.1-26.7,25.5c0,14.6,11.5,25.8,26.4,25.8c7.2,0,14.5-3.3,19.7-8.4l-5.1-5.7 C349.1,56.5,343.9,58.8,338.8,58.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "current",
    stroke: "current",
    points: "371,15.7 371,23.4 387,23.4 387,66.5 395.6,66.5 395.6,23.4 411.7,23.4 411.7,15.7  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "nn-logo",
    d: "M240.2,59V15.7h-8.4v36.5l-27.2-36.5h-8.4v36.5L172.2,20c0.8-1.3,1.2-2.8,1.2-4.3c0-4.7-3.8-8.6-8.6-8.6 c-4.7,0-8.6,3.9-8.6,8.6c0,3.2,1.7,5.9,4.3,7.4v43.3h8.6V30l27.1,36.4h8.4V30l24,32.1c-0.7,1.3-1.2,2.8-1.2,4.3 c0,4.7,3.9,8.6,8.6,8.6c4.7,0,8.6-3.9,8.6-8.6C244.6,63.2,242.8,60.5,240.2,59 M164.8,11.5c2.3,0,4.2,1.9,4.2,4.2v0.1 c0,0.2,0,0.4-0.1,0.6c-0.3,2-2.1,3.5-4.1,3.5c-2.3,0-4.2-1.9-4.2-4.2C160.6,13.4,162.5,11.5,164.8,11.5 M236,70.7 c-2.3,0-4.2-1.9-4.2-4.2c0-2.3,1.9-4.2,4.2-4.2c2.3,0,4.2,1.9,4.2,4.2C240.2,68.8,238.3,70.7,236,70.7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinnectWhite);
export default __webpack_public_path__ + "static/media/Thinnect_white.93e8be56177796155c1c01b162dd26bf.svg";
export { ForwardRef as ReactComponent };